import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "option" }

import { ITirPmDropdownOption, PopoverPositionEnum, TirPmDropdown, TirPmDropdownSizeEnum } from "tir-components";
import { PropType, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-pagination-show-more-elements',
  props: {
  countElements: { type: Number as PropType<number> },
  /**
   * Опции для дропдауна
   */
  options: { type: Array as PropType<number[]> },
},
  emits: ["update:countElements"],
  setup(__props, { emit }) {

const props = __props;




const selectOption = ref();

const selectedOptions = (value: object) => {
  selectOption.value = value;
  emit("update:countElements", selectOption.value.Id);
};

const optionDropdown: ITirPmDropdownOption[] = props.options.map((x) => {
  return { Id: x }; // Создаем объект с полем Id
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TirPmDropdown), {
      class: "dropdown",
      label: "",
      placeholder: 'Показывать по ' + (__props.countElements ? __props.countElements : ''),
      options: _unref(optionDropdown),
      "selected-option": selectOption.value,
      size: _unref(TirPmDropdownSizeEnum).Light,
      "popover-width": "auto",
      "option-list-scroll-height": "11rem",
      "popover-position": _unref(PopoverPositionEnum).Bottom
    }, {
      optionList: _withCtx(({ option }) => [
        _createElementVNode("div", {
          class: "option-block",
          onClick: ($event: any) => (selectedOptions(option))
        }, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(option.Id), 1)
        ], 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["placeholder", "options", "selected-option", "size", "popover-position"])
  ]))
}
}

})